import React, { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import Gallery from './Gallery';

const Typhoon = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContentType, setPopupContentType] = useState('');
  const [selectedImage, setSelectedImage] = useState(''); 

  const handlePopupOpen = (type, imgSrc) => {
    setPopupContentType(type);
    setSelectedImage(imgSrc); 
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupContentType('');
    setSelectedImage('');
  };

  return (
    <section className="t-sec">
      <div className="flex">
        <div className="high-left">
          <h4>Highlight</h4>
          <h5>Significant Visits Aboard</h5>
          <h2>Typhoon</h2>
          <p>A notable event for the Foundation was the visit to the Typhoon by the Prime Minister of Greece, Kyriakos Mitsotakis; the EU Commissioner for Environment, Oceans and Fisheries, Virginijus Sinkevičius; and the Minister of Maritime Affairs and Insular Policy, Christos Stylianides. Guided by the Foundation’s Chairman, Evi Lazou-Laskaridis, they toured the ship and were briefed on its capabilities and ongoing research activities.</p>
        </div>
        <div className="high-right">
          <Swiper navigation={true} modules={[Navigation]} className="highSwiper">
            <SwiperSlide>
              <img 
                src="img/typhoon/IMG_0188.jpg" 
                alt="typhoon" 
                className="popup-trigger" 
                onClick={() => handlePopupOpen('typhoon', 'img/typhoon/IMG_0188.jpg')}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img 
                src="img/typhoon/659b75b3-738b-4110-83e5-bb0d714e11c0.jpg" 
                alt="typhoon" 
                className="popup-trigger" 
                onClick={() => handlePopupOpen('typhoon', 'img/typhoon/659b75b3-738b-4110-83e5-bb0d714e11c0.jpg')}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img 
                src="img/typhoon/9a3830f6-bf6a-4b34-82ba-2950047d85e2.jpg" 
                alt="typhoon" 
                className="popup-trigger" 
                onClick={() => handlePopupOpen('typhoon', 'img/typhoon/9a3830f6-bf6a-4b34-82ba-2950047d85e2.jpg')}
              /> 
            </SwiperSlide>
            <SwiperSlide>
              <img 
                src="img/typhoon/DSCF2815.jpg" 
                alt="typhoon" 
                className="popup-trigger" 
                onClick={() => handlePopupOpen('typhoon', 'img/typhoon/DSCF2815.jpg')}
              />
            </SwiperSlide>
          </Swiper>
          <Gallery 
            isOpen={isPopupOpen} 
            contentType={popupContentType} 
            selectedImage={selectedImage} 
            onClose={handlePopupClose} 
          />
        </div>
      </div>
    </section>
  );
};

export default Typhoon;
